import mirpay from "./images/mirpay.png";
import sberpay from "./images/sberpay.png";
import sbp from "./images/sbp.svg";
import tbankpay from "./images/tbankpay.png";
import visaMastercard from "./images/visa-mastercard.png";

export const PAYMENT_CARDS_LOGO: Record<string, string> = {
  sberpay: sberpay,
  sbp: sbp,
  tinkoff: tbankpay,
  mir: mirpay,
  mastercard: visaMastercard,
  visa: visaMastercard,
};
